<style>
.v-counter {
  color: white;
}

label {
  color: white;
  display: flex;
  padding-left: 5px;
  font-weight: bold;
}
</style>
<template>
  <v-container>
    <v-layout row>
      <v-flex xs12>
        <div v-show="loading === true">
          <div class="fingerprint-spinner">
            <div class="spinner-ring"></div>
            <div class="spinner-ring"></div>
            <div class="spinner-ring"></div>
            <div class="spinner-ring"></div>
            <div class="spinner-ring"></div>
            <div class="spinner-ring"></div>
            <div class="spinner-ring"></div>
            <div class="spinner-ring"></div>
            <div class="spinner-ring"></div>
          </div>
        </div>
        <div v-show="loading != true">
          <v-dialog
            transition="dialog-bottom-transition"
            v-model="reportDialog"
            width="auto"
            :fullscreen="$vuetify.breakpoint.xsOnly"
            style="border-radius: 10px; "
          >
            <v-card
              class="chatbackground"
              style=" border-radius: 10px; text-align: center;"
            >
              <div
                class="titles "
                style="
              padding: 13px; border-radius: 10px 10px 0px 0px; padding-bottom: 0px;"
              >
                <div
                  style="
              width: 47%;
              margin: auto;
              border-radius: 10px;
          "
                ></div>
              </div>
              <div
                class="titles hidden-sm-and-up"
                style="
              padding: 0px 13px 5px;   "
                v-touch="{
                  down: () => (reportDialog = false),
                }"
              >
                <div
                  style="
              background: white;
              height: 5px;
              width: 47%;
              margin: auto;
              border-radius: 10px;
          "
                  class="elevation-3"
                ></div>
              </div>
              <v-card-title
                class="titles  "
                style="text-transform: capitalize; margin:auto;"
                v-touch="{
                  down: () => (reportDialog = false),
                }"
              >
                <h3 style="color:white;font-size: 28px;margin:auto;">
                  Report {{ this.name }}
                </h3>
              </v-card-title>
              <v-autocomplete
                v-model="chosenReason"
                :items="reportAutocomplete"
                solo
                dense
                chips
                small-chips
                label="Report User Reason"
                :menu-props="menuProps"
                style="width: 90%; margin: auto; margin-top: 15px"
              >
                <template slot="selection" slot-scope="data" pa-5>
                  <v-chip
                    text-color="white"
                    :selected="data.selected"
                    close
                    class="primary"
                    @input="data.parent.selectItem(data.item)"
                  >
                    {{ data.item }}
                  </v-chip>
                </template>

                <template slot="item" slot-scope="data">
                  <v-list-tile-content v-text="data.item"></v-list-tile-content>
                </template>
              </v-autocomplete>

              <v-textarea
                v-model="reportReason"
                label="Additional Comments"
                solo
                style="width: 90%; margin: auto"
              >
              </v-textarea>

              <v-card-actions style="display: block;">
                <v-spacer></v-spacer>
                <v-btn
                  class="danger elevation-4"
                  text
                  @click="report(), $forceUpdate()"
                  style="border-radius:20px; color:white;     text-transform: none; font-weight: 600"
                >
                  Report
                </v-btn>
                <v-btn
                  class="titles elevation-4"
                  text
                  @click="resetReport(), $forceUpdate()"
                  style="border-radius:20px; color:white;     text-transform: none; font-weight: 600"
                >
                  Cancel
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog
            transition="dialog-bottom-transition"
            v-model="support"
            width="auto; "
            :fullscreen="$vuetify.breakpoint.xsOnly"
            style="border-radius: 10px"
          >
            <v-card
              class="chatbackground"
              style="border-radius: 10px; text-align: center; overflox-y: scroll;"
            >
              <div
                class="titles "
                style="
              padding: 13px; border-radius: 10px 10px 0px 0px; padding-bottom: 0px;"
              >
                <div
                  style="
              width: 47%;
              margin: auto;
              border-radius: 10px;
          "
                ></div>
              </div>
              <div
                class="titles hidden-sm-and-up"
                style="
              padding: 0px 13px 5px;   "
                v-touch="{
                  down: () => (support = false),
                }"
              >
                <div
                  style="
              background: white;
              height: 5px;
              width: 47%;
              margin: auto;
              border-radius: 10px;
          "
                  class="elevation-3"
                ></div>
              </div>
              <v-card-title
                class="titles"
                style="text-transform: capitalize; margin:auto;"
                v-touch="{
                  down: () => (support = false),
                }"
              >
                <h3 style="color:white;font-size: 28px; margin:auto;">
                  {{ supportDialog.title }}
                </h3>
              </v-card-title>
              <v-list
                chatbackground
                style="background: #fff0 !important; display: grid; width: 75%; padding-left: 10px; padding-right: 10px; margin: auto; max-height: 20vh; overflow-y: scroll; border-radius:10px; margin-top: 10px;"
              >
                <template v-for="supporter in supportDialog.supporter_ids">
                  <v-chip
                    :key="supporter.id + supporter.name"
                    @click="
                      (imageURL = ''),
                        $router.push('/profile/' + supporter.id),
                        (support = false),
                        $forceUpdate()
                    "
                    class="ma-2 primary elevation-4 supporterChip"
                    style=" height:25px; text-transform: capitalize; font-weight:800; justify-content: center; "
                    text-color="white"
                    >{{ supporter.name }}</v-chip
                  >
                </template></v-list
              >
              <v-btn
                class="titles elevation-4"
                text
                @click="support = false"
                style="border-radius:20px; color:white;margin-bottom: 10px;"
              >
                Close
              </v-btn>
            </v-card>
          </v-dialog>

          <v-dialog
            transition="dialog-bottom-transition"
            v-model="tagDialog"
            width="auto; "
            :fullscreen="$vuetify.breakpoint.xsOnly"
            style="border-radius: 10px"
          >
            <v-card
              class="chatbackground"
              style="border-radius: 10px; text-align: center; overflox-y: scroll;"
            >
              <div
                class="titles "
                style="
              padding: 13px; border-radius: 10px 10px 0px 0px; padding-bottom: 0px;"
              >
                <div
                  style="
              width: 47%;
              margin: auto;
              border-radius: 10px;
          "
                ></div>
              </div>
              <div
                class="titles hidden-sm-and-up"
                style="
              padding: 0px 13px 5px;   "
                v-touch="{
                  down: () => (tagDialog = false),
                }"
              >
                <div
                  style="
              background: white;
              height: 5px;
              width: 47%;
              margin: auto;
              border-radius: 10px;
          "
                  class="elevation-3"
                ></div>
              </div>
              <v-card-title
                class="titles"
                style="text-transform: capitalize; margin:auto;"
                v-touch="{
                  down: () => (tagDialog = false),
                }"
              >
                <h3 style="color:white;font-size: 28px; margin:auto;">
                  Interest Tags
                </h3>
              </v-card-title>
              <v-list
                chatbackground
                style="background: #fff0 !important; display: grid; width: 75%; padding-left: 10px; padding-right: 10px; margin: auto; max-height: 20vh; overflow-y: scroll; border-radius:10px; margin-top: 10px;"
              >
                <template v-for="tag in profileTags">
                  <v-chip
                    :key="tag + 'dialog'"
                    @click="pushTag(tag)"
                    class="ma-2 primary elevation-4 supporterChip"
                    style=" height:25px; text-transform: capitalize; font-weight:800; justify-content: center; "
                    text-color="white"
                    >{{ tag }}</v-chip
                  >
                </template></v-list
              >
              <v-btn
                class="titles elevation-4"
                text
                @click="tagDialog = false"
                style="border-radius:20px; color:white;margin-bottom: 10px;"
              >
                Close
              </v-btn>
            </v-card>
          </v-dialog>

          <v-dialog
            transition="dialog-bottom-transition"
            v-model="contact"
            width="auto"
            :fullscreen="$vuetify.breakpoint.xsOnly"
            style="border-radius: 10px"
          >
            <v-card
              class="chatbackground"
              style="border-radius: 10px; text-align: center; padding: 10px; padding-bottom:0px"
            >
              <div
                class="titles "
                style="
              padding: 13px; border-radius: 10px 10px 0px 0px; padding-bottom: 0px;"
              >
                <div
                  style="
              width: 47%;
              margin: auto;
              border-radius: 10px;
          "
                ></div>
              </div>
              <div
                class="titles hidden-sm-and-up"
                style="
              padding: 0px 13px 5px;   "
                v-touch="{
                  down: () => (contact = false),
                }"
              >
                <div
                  style="
              background: white;
              height: 5px;
              width: 47%;
              margin: auto;
              border-radius: 10px;
          "
                  class="elevation-3"
                ></div>
              </div>
              <div
                class="titles"
                style=" border-radius: 0 0 10px 10px; padding:10px; margin:auto;"
              >
                <h2 style="color: white; text-transform: capitalize;">
                  {{ this.name }}
                </h2>
                <div
                  flat
                  style="margin-top:10px; margin-bottom:10px;color: white; border-radius: 10px; display: flex; justify-content: center;     align-items: center;"
                  v-if="emailSwitch"
                >
                  <h3>Email: &nbsp;&nbsp;</h3>
                  <h4 @click="email" style="text-decoration-line: underline;">
                    {{ this.userEmail }}
                  </h4>
                </div>
              </div>
              <v-btn
                flat
                style="border-radius: 20px; margin-top: 10px;"
                class="titles elevation-4"
                @click="contact = false"
              >
                <span style="color:white; ">Close</span>
              </v-btn>
            </v-card>
          </v-dialog>

          <v-snackbar v-model="snackbar" bottom :timeout="3000" color="titles">
            Your Profile Has Been Saved
          </v-snackbar>

          <v-card
            class=" elevation-5 primary"
            style="margin: auto; margin-bottom: 10px; width: 95%;padding: 20px;border-radius: 10px;"
          >
            <div v-if="!editing">
              <div class="hidden-sm-and-down">
                <div
                  style="display: flex;    margin: auto;justify-content: center;"
                >
                  <div v-show="imageURLExist">
                    <v-avatar
                      :size="300"
                      color="rgb(255, 0, 0, 0)"
                      style="margin: auto; display: inline-flex;"
                    >
                      <img
                        :src="this.imageUrl"
                        style=" border: 2px solid white; width: 225px; height: 225px; object-fit: cover; border-radius:20px;"
                      />
                    </v-avatar>
                  </div>
                  <div v-show="!imageURLExist">
                    <v-avatar
                      :size="250"
                      color="rgb(255, 0, 0, 0)"
                      style="margin: auto; display: inline-flex;"
                    >
                      <v-icon
                        dark
                        flat
                        style="font-size:130px; color:white; border: 2px solid white; border-radius:20px;"
                        >person</v-icon
                      >
                    </v-avatar>
                  </div>

                  <div
                    style="display: inline-block; margin: auto; margin-left: 10px; margin-right:10px;"
                  >
                    <h1 style="color:white; text-transform: capitalize;">
                      {{ this.name }}
                    </h1>
                    <h2 style="color:white;">@{{ this.username }}</h2>
                    <div
                      style="display: inline-flex; width: 100%;  margin: 0px; align-items: center; margin-top:10px; margin-right:10px; "
                    >
                      <div
                        style="display: inline-flex; border:1px white solid; border-radius:10px; justify-content: flex-start; margin-right: 5px;"
                      >
                        <div
                          class="white--text"
                          @click="setDialog(supporter_ids, 'Supporters')"
                          style="margin:10px;  background: transparent; text-align-last: start;"
                        >
                          <p style="font-weight: bold; margin-bottom: 0px;">
                            {{ this.supporter_ids.length }} Supporters
                          </p>
                        </div>
                        <div
                          class="white--text"
                          @click="setDialog(promoted_accounts, 'Supporting')"
                          style="padding:10px; background: transparent;text-align-last: start; "
                        >
                          <p style="font-weight: bold; margin-bottom: 0px;">
                            {{ this.promoted_accounts.length }} Supporting
                          </p>
                        </div>
                      </div>

                      <div v-show="isCurrentUser()">
                        <v-btn
                          outline
                          color="secondary"
                          @click="onClickEdit"
                          style=" border-radius: 10px;  font-weight: bold; text-transform: none; height:43px;"
                        >
                          <!-- change to secondary color -->
                          <v-icon
                            dark
                            flat
                            style="font-size:25px; color:#F1CE3E; "
                            >create</v-icon
                          >
                        </v-btn>
                      </div>

                      <div v-show="!isCurrentUser() && !follow">
                        <v-btn
                          outline
                          color="secondary"
                          @click="Follow"
                          style="border-radius: 10px;  font-weight: bold; height:43px;    background-color: #014A3C !important;"
                        >
                          <v-icon
                            dark
                            flat
                            style="font-size:25px; color:#F1CE3E;"
                            >person_add_alt_1</v-icon
                          >
                        </v-btn>
                      </div>
                      <div v-show="!isCurrentUser() && follow">
                        <v-btn
                          outline
                          color="secondary"
                          @click="Unfollow"
                          style="border-radius: 10px;   font-weight: bold; height:43px;  "
                        >
                          <v-icon
                            dark
                            flat
                            style="font-size:25px; color:#F1CE3E; "
                            >person_remove</v-icon
                          >
                        </v-btn>
                      </div>

                      <div v-if="emailSwitch">
                        <v-btn
                          outline
                          color="secondary"
                          @click="contact = true"
                          style=" border-radius: 10px;  font-weight: bold; text-transform: none; height:43px;"
                        >
                          <v-icon
                            dark
                            flat
                            style="font-size:25px; color:#F1CE3E;"
                            >contact_mail</v-icon
                          >
                        </v-btn>
                      </div>
                    </div>
                    <v-list
                      v-show="profileTags.length > 0"
                      style="background-color:#00ffff00; margin-left: -8px;"
                    >
                      <template v-for="(tag, i) in profileTags">
                        <v-chip
                          v-if="i < 2"
                          :key="tag + i + userID + 'desk'"
                          @click="pushTag(tag)"
                          class="ma-2 titles elevation-4"
                          style="height:25px;"
                          text-color="white"
                          >{{ tag }}</v-chip
                        >
                        <v-chip
                          v-else-if="i == 2"
                          :key="tag + i + userID + 'desk'"
                          class="ma-2 titles elevation-4"
                          style="height:25px;"
                          text-color="white"
                          @click="tagDialog = true"
                          >+&nbsp;{{ profileTags.length - 2 }}</v-chip
                        >
                      </template>

                      <v-chip
                        v-if="stateSwitch"
                        :key="state + userID + 'desk'"
                        @click="pushTag(state)"
                        class="ma-2 secondary elevation-4 titles--text"
                        style="height:25px;"
                        text-color="white"
                        >{{ state }}</v-chip
                      >
                    </v-list>
                    <p style="color:white; font-weight: 600;">{{ this.bio }}</p>
                  </div>
                </div>
              </div>
              <div class="hidden-md-and-up" style="text-align: -webkit-center;">
                <div style=" display: inline-grid;">
                  <div
                    style="display: flex;justify-content: center;align-items: center;"
                  >
                    <v-avatar
                      v-show="imageURLExist"
                      :size="150"
                      color="rgb(255, 0, 0, 0)"
                      style="display: inline-flex;"
                    >
                      <img
                        :src="this.imageUrl"
                        style=" border: 2px solid white; width: 100px;height: 100px;object-fit: cover; border-radius:20px;"
                      />
                    </v-avatar>
                    <v-avatar
                      v-show="!imageURLExist"
                      :size="100"
                      color="rgb(255, 0, 0, 0)"
                      style="display: inline-flex;"
                    >
                      <v-icon
                        dark
                        flat
                        style="font-size:70px; color:white; border: 2px solid white; border-radius:20px;"
                        >person</v-icon
                      >
                    </v-avatar>
                    <div
                      style="margin-left: 10px; max-width:62vw; overflow-wrap:anywhere;"
                    >
                      <h1
                        style="color:white; text-transform: capitalize; font-size: 4vw;"
                      >
                        {{ this.name }}
                      </h1>
                      <h2 style="color:white; font-size: 3vw;">
                        @{{ this.username }}
                      </h2>
                    </div>
                  </div>
                  <div
                    style="display: flex; align-items: center; justify-content: center; flex-direction: row;flex-wrap: wrap;"
                  >
                    <div
                      style="display: inline-flex; width: fit-content; border: 1px white solid; border-radius: 10px; margin: 5px; height: 50px; align-items: center;"
                    >
                      <div
                        @click="setDialog(supporter_ids, 'Supporters')"
                        elevation-0
                        style="margin:10px; background: transparent; "
                      >
                        <p
                          style="font-weight: bold; margin-bottom:0px;"
                          class="white--text"
                        >
                          {{ this.supporter_ids.length }} Supporters
                        </p>
                      </div>
                      <div
                        @click="setDialog(promoted_accounts, 'Supporting')"
                        style="padding:10px;  background: transparent;"
                      >
                        <p
                          style="font-weight: bold; margin-bottom:0px;"
                          class="white--text"
                        >
                          {{ this.promoted_accounts.length }} Supporting
                        </p>
                      </div>
                    </div>

                    <div
                      style="    display: flex;
    height: 60px;
        align-items: center;
"
                    >
                      <div
                        v-show="!isCurrentUser() && !follow"
                        style=" width:fit-content; display: flex;justify-content: center; margin:5px; height: 100%"
                      >
                        <v-btn
                          outline
                          @click="Follow"
                          color="secondary"
                          class="smallButton"
                          style="border-radius: 10px;  font-weight: bold; text-transform: none; padding: 0px; margin:5px; height: auto; background-color: #014A3C !important;"
                        >
                          <v-icon
                            dark
                            flat
                            style="font-size:25px; color:#F1CE3E;"
                            >person_add_alt_1</v-icon
                          >
                        </v-btn>
                      </div>
                      <div
                        v-show="!isCurrentUser() && follow"
                        style=" width:fit-content; display: flex;justify-content: center; margin:5px; height: 100%"
                      >
                        <v-btn
                          outline
                          @click="Unfollow"
                          color="secondary"
                          class="smallButton"
                          style="border-radius: 10px;  font-weight: bold; text-transform: none; padding: 0px; margin:5px; height: auto;  "
                        >
                          <v-icon
                            dark
                            flat
                            style="font-size:25px; color:#F1CE3E;"
                            >person_remove</v-icon
                          >
                        </v-btn>
                      </div>
                      <div
                        v-show="isCurrentUser()"
                        style=" width:fit-content; display: flex;justify-content: center; margin:0px; height: 100%"
                      >
                        <v-btn
                          outline
                          @click="onClickEdit"
                          color="secondary"
                          class="smallButton"
                          style="border-radius: 10px; font-weight: bold; text-transform: none; padding: 0px; margin:5px; height: auto;  "
                        >
                          <!-- change to secondary color -->
                          <v-icon
                            dark
                            flat
                            style="font-size:25px; color:#F1CE3E;"
                            >create</v-icon
                          >
                        </v-btn>
                      </div>
                      <div
                        style=" width:fit-content; display: flex;justify-content: center; margin:0px; height: 100%"
                        v-if="emailSwitch"
                      >
                        <v-btn
                          outline
                          @click="contact = true"
                          color="secondary"
                          class="smallButton"
                          style="border-radius: 10px; font-weight: bold; text-transform: none; padding: 0px; margin:5px; height: auto;  "
                        >
                          <v-icon
                            dark
                            flat
                            style="font-size:25px; color:#F1CE3E;"
                            >contact_mail</v-icon
                          >
                        </v-btn>
                      </div>
                    </div>
                  </div>

                  <div style="display: inline-block; margin: auto;">
                    <v-list
                      v-show="profileTags.length > 0"
                      style="background-color:#00ffff00; margin-left: -8px;"
                    >
                      <template v-for="(tag, i) in profileTags">
                        <v-chip
                          v-if="i < 2"
                          :key="tag + i + userID + 'mobile'"
                          @click="pushTag(tag)"
                          class="ma-2 titles elevation-4"
                          style="height:25px;"
                          text-color="white"
                          >{{ tag }}</v-chip
                        >
                        <v-chip
                          v-else-if="i == 2"
                          :key="tag + i + userID + 'mobile'"
                          class="ma-2 titles elevation-4"
                          style="height:25px;"
                          text-color="white"
                          @click="tagDialog = true"
                          >+&nbsp;{{ profileTags.length - 2 }}</v-chip
                        >
                      </template>

                      <v-chip
                        v-if="stateSwitch"
                        :key="state + userID + 'mobile'"
                        @click="pushTag(state)"
                        class="ma-2 secondary elevation-4 titles--text"
                        style="height:25px;"
                        text-color="white"
                        >{{ state }}</v-chip
                      >
                    </v-list>
                    <p style="color:white; font-weight: 600;">{{ this.bio }}</p>
                  </div>
                </div>
              </div>

              <div
                v-if="
                  ((filtered('comments').length > 0 &&
                    isCurrentUser()) ||
                    filtered('likes').length > 0) 
                "
                style="text-align: center; margin:5px; border-radius: 10px; padding: 10px"
                class="chatbackground"
              >
                <h3 class="titles--text">Interactions</h3>
                <v-btn
                  v-if="filtered('likes').length > 0 && isCurrentUser"
                  @click="
                    (resourceShow = !resourceShow),
                      (resourceDiscussShow = false),
                      (type = 'likes')
                  "
                  class=" elevation-4"
                  style="border-radius: 10px; color:white; width: 150px;"
                  v-bind:color="resourceShow === true ? 'primary' : 'titles'"
                >
                  <v-icon color="secondary" dark style="font-size:20px; "
                    >star</v-icon
                  >
                  &nbsp; Stars
                </v-btn>
                <v-btn
                  v-if="filtered('comments').length > 0"
                  @click="
                    (resourceDiscussShow = !resourceDiscussShow),
                      (resourceShow = false),
                      (type = 'comments')
                  "
                  class="elevation-4"
                  style="border-radius: 10px; color:white;  width: 150px;"
                  v-bind:color="
                    resourceDiscussShow === true ? 'primary' : 'titles'
                  "
                >
                  <v-icon color="secondary" dark style="font-size:20px; "
                    >speaker_notes</v-icon
                  >
                  &nbsp; Comments
                </v-btn>
                <!-- <h4 v-if="resourceShow" style="margin-top: 5px;"> Stars </h4>
                <h4 v-if="resourceDiscussShow" style="margin-top: 5px;"> Comments </h4> -->

                <div
                  style="margin-top: 10px; text-align: start;"
                  v-show="resourceShow || resourceDiscussShow"
                >
                  <v-list
                    class="elevation-0 hidden-sm-and-down"
                    two-line
                    style=" border-radius: 10px; padding-bottom: 1px; background-color:#fff0; display: grid; grid-template-columns: repeat(auto-fit,minmax(34%, 1fr)); column-gap: 15px;"
                  >
                    <template
                      v-for="resource in filtered(type)"
                      pa-1
                      style="  padding-left: 10px; "
                    >
                      <div
                        :key="resource.id + 'mobile'"
                        @click="openPost(resource)"
                        class="elevation-2 search"
                        style="border-radius: 10px;  padding: 20px; margin-bottom: 10px; display: flex; align-items: center; "
                      >
                        <v-card flat pa-1 class="search" style="width:100%;">
                          <p
                            class="text-wrap"
                            style="font-weight: bold;font-size: 16px;margin-bottom: 0px;padding-left: 10px;overflow-wrap: break-word;padding-right: 10px; white-space: normal; word-wrap: break-word; width: auto; text-transform: capitalize;"
                            pa-1
                          >
                            <v-icon
                            v-if="resourceShow"
                              color="secondary"
                              class="titles"
                              dark
                              style="font-size:20px; border-radius: 20px; padding: 3px; float: right;"
                              >star</v-icon
                            >
                            <v-icon
                            v-else
                              color="secondary"
                              class="titles"
                              dark
                              style="font-size:18px; border-radius: 20px; padding: 6px; float: right;"
                              >speaker_notes</v-icon
                            >
                            {{ resource.title }}
                          </p>

                          <v-list style="background: #edefee;">
                            <div v-show="resource.tags.length > 0">
                              <template v-for="(tag, i) in resource.tags">
                                <v-chip
                                  v-if="
                                    i < 2 &&
                                      (resource.tags.length != 2 || i == 0)
                                  "
                                  :key="tag + 'desktop' + resource.id"
                                  @click="pushTag(tag)"
                                  class="ma-2 titles elevation-4"
                                  style="height:25px;"
                                  text-color="white"
                                  >{{ tag }}</v-chip
                                >
                                <v-chip
                                  v-else-if="
                                    i == 2 &&
                                      resource.tags.length != 3 &&
                                      resource.tags.length != 2
                                  "
                                  :key="tag + 'desktop' + resource.id"
                                  class="ma-2 titles elevation-4"
                                  @click="pushTag(tag)"
                                  style="height:25px;"
                                  text-color="white"
                                  >+&nbsp;{{ resource.tags.length - 3 }}</v-chip
                                >
                                <v-chip
                                  v-else-if="i == resource.tags.length - 1"
                                  :key="tag + 'desktop' + resource.id"
                                  @click="pushTag(tag)"
                                  class="ma-2 secondary elevation-4 titles--text"
                                  style="height:25px;"
                                  text-color="white"
                                  >{{ tag }}</v-chip
                                >
                              </template>
                            </div>
                          </v-list>
                          <p
                            pa-2
                            style="display: inline; font-weight: bold;padding-top: 2px;padding-left: 10px;margin-bottom: 0px; text-transform: uppercase;"
                            class="text-wrap"
                          >
                            {{ resource.time }}
                          </p>
                          <br />
                          <p
                            v-if="resource.comment"
                            pa-2
                            style="display: inline; font-weight: bold;padding-top: 2px;padding-left: 10px;margin-bottom: 0px;"
                            class="text-wrap"
                          >
                            '{{ resource.comment.substring(0, 100).trim()
                            }}<strong v-if="resource.comment.length > 99"
                              >...</strong
                            >'
                          </p>
                        </v-card>
                      </div>
                    </template>
                  </v-list>
                  <v-list
                    class="elevation-0 hidden-md-and-up"
                    two-line
                    style=" border-radius: 10px; padding-bottom: 1px; background-color:#fff0;"
                  >
                    <template
                      v-for="resource in filtered(type)"
                      pa-1
                      style="  padding-left: 10px; "
                    >
                      <div
                        :key="resource.id + 'desktop'"
                        @click="openPost(resource)"
                        class="elevation-2 search"
                        style="border-radius: 10px;  padding: 20px; margin-bottom: 10px; "
                      >
                        <v-card flat pa-1 class="search" style="width:100%;">
                          <p
                            class="text-wrap"
                            style="font-weight: bold;font-size: 16px;margin-bottom: 0px;padding-left: 10px;overflow-wrap: break-word;padding-right: 10px; white-space: normal; word-wrap: break-word; width: auto; text-transform: capitalize;"
                            pa-1
                          >
                            <v-icon
                            v-if="resourceShow"
                              dark
                              color="secondary"
                              class="titles"
                              style="font-size:20px; border-radius: 20px; padding: 3px; float: right;"
                              >star</v-icon
                            >
                            <v-icon
                            v-else
                              dark
                              color="secondary"
                              class="titles"
                              style="font-size:18px; border-radius: 20px; padding: 6px; float: right;"
                              >speaker_notes</v-icon
                            >
                            {{ resource.title }}
                          </p>

                          <v-list style="background: #edefee;">
                            <div v-show="resource.tags.length > 0">
                              <template v-for="(tag, i) in resource.tags">
                                <v-chip
                                  v-if="
                                    i < 2 &&
                                      (resource.tags.length != 2 || i == 0)
                                  "
                                  :key="tag + 'desktop' + resource.id"
                                  @click="pushTag(tag)"
                                  class="ma-2 titles elevation-4"
                                  style="height:25px;"
                                  text-color="white"
                                  >{{ tag }}</v-chip
                                >
                                <v-chip
                                  v-else-if="
                                    i == 2 &&
                                      resource.tags.length != 3 &&
                                      resource.tags.length != 2
                                  "
                                  :key="tag + 'desktop' + resource.id"
                                  class="ma-2 titles elevation-4"
                                  @click="pushTag(tag)"
                                  style="height:25px;"
                                  text-color="white"
                                  >+&nbsp;{{ resource.tags.length - 3 }}</v-chip
                                >
                                <v-chip
                                  v-else-if="i == resource.tags.length - 1"
                                  :key="tag + 'desktop' + resource.id"
                                  @click="pushTag(tag)"
                                  class="ma-2 secondary elevation-4 titles--text"
                                  style="height:25px;"
                                  text-color="white"
                                  >{{ tag }}</v-chip
                                >
                              </template>
                            </div>
                          </v-list>
                          <p
                            pa-2
                            style="display: inline; font-weight: bold;padding-top: 2px;padding-left: 10px;margin-bottom: 0px; text-transform: uppercase;"
                            class="text-wrap"
                          >
                            {{ resource.time }}
                          </p>
                          <br />
                          <p
                            v-if="resource.comment"
                            pa-2
                            style="display: inline; font-weight: bold;padding-top: 2px;padding-left: 10px;margin-bottom: 0px;"
                            class="text-wrap"
                          >
                            '{{ resource.comment.substring(0, 100).trim()
                            }}<strong v-if="resource.comment.length > 99"
                              >...</strong
                            >'
                          </p>
                        </v-card>
                      </div>
                    </template>
                  </v-list>
                </div>
              </div>

              <div
                style="text-align-last: center; margin: auto; width: fit-content;"
              >
                <v-btn
                  color="danger"
                  dark
                  style="border-radius:20px; "
                  @click="dialog = true"
                  v-show="isCurrentUser()"
                >
                  Sign Out
                </v-btn>
                <v-btn
                  color="danger"
                  dark
                  style="border-radius:20px; "
                  v-show="!isCurrentUser()"
                  @click="reportDialog = true"
                >
                  Report
                </v-btn>
              </div>

              <div class="text-center">
                <v-dialog
                  transition="dialog-bottom-transition"
                  v-model="dialog"
                  width="auto"
                  :fullscreen="$vuetify.breakpoint.xsOnly"
                >
                  <v-card
                    style="border-radius: 10px"
                    class="chatbackground white--text"
                  >
                    <div
                      class="titles "
                      style=" padding: 13px; border-radius: 10px 10px 0px 0px; padding-bottom: 0px;"
                    >
                      <div
                        style=" width: 47%; margin: auto;  border-radius: 10px;"
                      ></div>
                    </div>
                    <div
                      class="titles hidden-sm-and-up"
                      style=" padding: 0px 13px 5px;   "
                      v-touch="{
                        down: () => (dialog = false),
                      }"
                    >
                      <div
                        style="
                            background: white;
                            height: 5px;
                            width: 47%;
                            margin: auto;
                            border-radius: 10px;
                        "
                        class="elevation-3"
                      ></div>
                    </div>
                    <v-card-title
                      class="titles  "
                      style="text-align: center"
                      v-touch="{
                        down: () => (dialog = false),
                      }"
                    >
                      <h4 style="color:white; font-size: 28px;   margin: auto;">
                        Sign Out
                      </h4>
                    </v-card-title>

                    <h4 style="text-align: center; padding:10px; color: black;">
                      Are you sure you want to log out?
                    </h4>

                    <v-card-actions style="justify-content: center;">
                      <v-btn
                        flat
                        :to="{ name: 'signout' }"
                        style="border-radius: 20px;"
                        class="danger elevation-4 white--text"
                        @click="dialog = false"
                        >Sign Out
                      </v-btn>
                      <v-btn
                        flat
                        style="border-radius: 20px;"
                        class="titles elevation-4 white--text"
                        @click="dialog = false"
                        >Cancel
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>
            </div>
            <div v-else style="text-align: center">
              <v-btn
                fab
                v-if="userProfile.profile"
                small
                color="red"
                @click="onCloseEdit"
                style="border-radius: 20px; float:right"
              >
                <v-icon dark flat style="font-size:25px; color:white; "
                  >close</v-icon
                >
              </v-btn>
              <h1 style="color:white; text-align: left;">
                Edit Your Profile:
              </h1>
              <v-form style="margin-top:10px">
                <fieldset>
                  <legend>Profile Picture</legend>
                  <v-flex style="margin:10px">
                    <!-- change to primary color -->

                    <div v-show="imageURLExist">
                      <v-avatar
                        color="rgb(255, 0, 0, 0)"
                        style="margin: auto; display: inline-flex;"
                        size="20vw"
                      >
                        <img
                          :src="this.imageUrl"
                          style=" border: 2px solid white; border-radius:20px; width: 20vw; height: 20vw; object-fit: cover;"
                        />
                      </v-avatar>
                    </div>
                    <div v-show="!imageURLExist">
                      <v-avatar
                        :size="150"
                        color="rgb(255, 0, 0, 0)"
                        style="margin: auto; display: inline-flex;"
                      >
                        <v-icon
                          dark
                          flat
                          style="font-size:100px; color:white; border: 2px solid white; border-radius:20px;"
                          >person</v-icon
                        >
                      </v-avatar>
                    </div>
                  </v-flex>
                  <v-flex>
                    <v-btn
                      raised
                      class="titles"
                      @click="onPickFile"
                      style="border-radius: 20px; margin-left: 0px; margin-right: 0px; color:white;"
                    >
                      <v-icon dark style="font-size:22px; color:white;"
                        >publish</v-icon
                      >&nbsp;&nbsp;Upload Image
                    </v-btn>
                    <input
                      type="file"
                      style="display: none"
                      ref="fileInput"
                      accept="image/*"
                      @change="onFilePicked"
                    />
                  </v-flex>
                </fieldset>
                <fieldset>
                  <legend>Account Information</legend>
                  <label>First Name**</label>
                  <v-flex>
                    <v-text-field
                      v-model="editedFirstName"
                      label="**First Name"
                      hint="**First Name"
                      single-line
                      solo
                      required
                      style=" display: block; text-transform: capitalize;"
                      v-on:keyup.enter="nothing()"
                    ></v-text-field>
                  </v-flex>
                  <label>Last Name**</label>
                  <v-flex>
                    <v-text-field
                      v-model="editedLastName"
                      label="**Last Name"
                      hint="**Last Name"
                      single-line
                      required
                      solo
                      style="text-transform: capitalize;"
                      v-on:keyup.enter="nothing()"
                    ></v-text-field>
                  </v-flex>
                  <label>Bio</label>
                  <v-flex>
                    <v-textarea
                      v-model="editedBio"
                      label="Bio"
                      maxlength="200"
                      counter="200"
                      rows="2"
                      solo
                      v-on:keyup.enter="nothing()"
                    ></v-textarea>
                  </v-flex>
                  <label>Phone*</label>
                  <v-flex style="display: flex;">
                    <v-text-field
                      v-model="editedPhone"
                      label="*Phone"
                      hint="*Phone"
                      mask="(###)-###-####"
                      single-line
                      solo
                      v-on:keyup.enter="nothing()"
                    ></v-text-field>
                    <!-- <v-btn style="border-radius: 10px;" @click="sendCode()" v-if="!codeSent"> Send Code </v-btn> -->
                  </v-flex>
                  <!-- <v-flex v-if="codeSent" style="display: flex;">
                    <v-text-field
                      v-model="verifyCode"
                      label="*One Time Code"
                      hint="*One Time Code"
                      single-line
                      autocomplete="one-time-code"
                      solo
                      v-on:keyup.enter="nothing()"
                    ></v-text-field> 
                    <v-btn style="border-radius: 10px;" @click="verifyOneCode()"> Verify </v-btn>
                  </v-flex> -->
                  <label>Gender*</label>
                  <v-flex>
                    <v-select
                      v-model="editedGender"
                      :items="genders"
                      label="*Gender"
                      hint="*Gender"
                      single-line
                      solo
                      v-on:keyup.enter="nothing()"
                    ></v-select>
                  </v-flex>
                  <label>
                    Birthdate*
                  </label>
                  <v-flex
                    style="margin-bottom:10px; display: flex; flex-direction: column;"
                  >
                    <!-- <div
                      class="elevation-3"
                      style="display:flex; background:white; height: 48px; padding-left: 12px; padding: 5px; border-radius: 10px;"
                    > -->
                    <div
                      class="elevation-3"
                      style="display:inline; background:white; padding: 5px; border-radius: 10px;"
                    >
                      <v-menu
                        v-model="datemenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="editedBirthday"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="editedBirthday"
                          @input="datemenu = false"
                          max="2007-01-01"
                        ></v-date-picker>
                      </v-menu>
                      <!-- <input
                        type="date"
                        v-model="editedBirthday"
                        @input="datemenu = false"
                        max="2007-01-01"
                        min="1900-01-01"
                        class="calen"
                      /> -->
                    </div>
                  </v-flex>
                </fieldset>

                <fieldset>
                  <legend>Algorithm Information</legend>
                  <label>Zipcode</label>
                  <v-flex>
                    <v-text-field
                      v-model="editedZipcode"
                      label="Zipcode"
                      hint="Zipcode"
                      single-line
                      solo
                      v-on:keyup.enter="nothing()"
                    ></v-text-field>
                  </v-flex>
                  <label>Location**</label>
                  <v-flex style="margin-bottom: 15px;">
                    <v-autocomplete
                      v-model="editedState"
                      :items="possibleTags.location"
                      cache-items
                      flat
                      hide-no-data
                      hide-details
                      label="**Location"
                      solo
                      dense
                      required
                    >
                      <template slot="selection" slot-scope="data" pa-5>
                        <v-chip
                          class="titles elevation-4"
                          text-color="white"
                          :selected="data.selected"
                          @input="data.parent.selectItem(data.item)"
                        >
                          {{ data.item }}
                        </v-chip>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <label>Your Interest Tags**</label>
                  <v-flex>
                    <v-autocomplete
                      v-model="chosenTags"
                      :items="possibleTags.topics"
                      solo
                      denses
                      chips
                      small-chips
                      label="**Your Interest Tags"
                      multiple
                      :menu-props="menuProps"
                      @input="adjustOptions"
                      style="margin-bottom: 8px;"
                    >
                      <template slot="selection" slot-scope="data" pa-5>
                        <v-chip
                          text-color="white"
                          :selected="data.selected"
                          close
                          class="chip--select-multi titles"
                          @input="data.parent.selectItem(data.item)"
                        >
                          {{ data.item }}
                        </v-chip>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                </fieldset>

                <fieldset>
                  <legend>Public Information</legend>
                  <v-switch
                    v-model="emailSwitch"
                    dark
                    label="Share Email"
                    color="titles"
                    style="display: inline-block; margin-left: 10px; margin-top:10px"
                  ></v-switch>
                  <v-switch
                    v-model="stateSwitch"
                    dark
                    label="Share State"
                    color="titles"
                    style="display: inline-block; margin-left: 10px; margin-top:10px"
                  ></v-switch>
                </fieldset>

                <fieldset>
                  <legend>Notifications</legend>
                  <v-switch
                    v-model="newsletter"
                    dark
                    label="Receive Newsletter"
                    color="titles"
                    style="display: inline-block; margin-left: 10px; margin-top:10px"
                  ></v-switch>
                </fieldset>

                <v-alert
                  color="red"
                  v-show="verified"
                  style="border-radius: 20px;"
                  >{{ errorUpdateMessage }}</v-alert
                >

                <v-btn
                  color="red"
                  @click="onCloseEdit"
                  v-if="userProfile.profile"
                  style="border-radius: 20px; color:white"
                >
                  <v-icon dark style="font-size:22px; ">close</v-icon
                  >&nbsp;&nbsp;Cancel
                </v-btn>
                <v-btn
                  class="titles"
                  @click="onUpdateProfile"
                  style="border-radius: 20px; color:white"
                >
                  <v-icon dark style="font-size:22px; ">create</v-icon
                  >&nbsp;&nbsp;Save Changes
                </v-btn>

                <h4 style="color:white; font-style: italic; margin-top: 5px;">
                  Entries marked with "**" and your Bio will be displayed
                  publicly
                </h4>
              </v-form>
            </div>
          </v-card>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

import firebase from "firebase";
import "firebase/firestore";

export default {
  data() {
    return {
      reportDialog: false,
      chosenReason: "",
      reportReason: "",
      reportAutocomplete: [
        "Inappropriate language, hate speech, racist language, and profanity",
        "Spam",
        "Harassment or Threats",
        "Solicitation",
        "Other",
      ],
      verified: false,
      contact: false,
      emailSwitch: false,
      imageURLExist: false,
      datemenu: false,
      support: false,
      supportDialog: {
        title: "",
        supporter_ids: [],
      },
      dialog: false,
      resourceShow: false,
      resourceDiscussShow: false,
      loading: true,
      editing: true,
      userID: null,
      userEmail: "",
      username: "",
      bio: "",
      subscribed: false,
      name: "",
      avatar: "",
      imageUrl: "",
      updated: "",
      type: "likes",
      gender: "",
      location: "",
      birthdate: "",
      zipcode: "",
      state: "",
      comment_count: 0,
      menuProps: {
        disabled: false,
      },
      maxSelected: 2,
      supporter_ids: "",
      promoted_accounts: "",
      editedFirstName: "",
      editedLastName: "",
      editedUsername: "",
      editedAvatar: "",
      editedBio: "",
      editedPhone: "",
      editedLocation: "",
      editedZipcode: "",
      editedState: "",
      editedBirthday: "",
      editedGender: "",
      newsletter: true,
      possibleTags: {
        occupation: [],
        topics: [
          "Congress",
          "Environment",
          "Education",
          "Supreme Court",
          "Public Health",
          "Public Safety",
          "Military",
          "Economy",
          "International Affairs",
          "Social Justice",
          "Federal Spending",
          "Technology",
          "Entertainment",
          "Human Rights",
          "Litigation",
          "Politics",
        ],
        location: [
          "Alabama",
          "Alaska",
          "American Samoa",
          "Arizona",
          "Arkansas",
          "California",
          "Colorado",
          "Connecticut",
          "Delaware",
          "Washington D.C.",
          "Florida",
          "Georgia",
          "Guam",
          "Hawaii",
          "Idaho",
          "Illinois",
          "Indiana",
          "International",
          "Iowa",
          "Kansas",
          "Kentucky",
          "Louisiana",
          "Maine",
          "Maryland",
          "Massachusetts",
          "Michigan",
          "Minnesota",
          "Mississippi",
          "Missouri",
          "Montana",
          "Nebraska",
          "Nevada",
          "New Hampshire",
          "New Jersey",
          "New Mexico",
          "New York",
          "North Carolina",
          "North Dakota",
          "Northern Mariana Islands",
          "Ohio",
          "Oklahoma",
          "Oregon",
          "Pennsylvania",
          "Puerto Rico",
          "Rhode Island",
          "South Carolina",
          "South Dakota",
          "Tennessee",
          "Texas",
          "U.S. Virgin Islands",
          "Utah",
          "Vermont",
          "Virginia",
          "Washington",
          "West Virginia",
          "Wisconsin",
          "Wyoming",
        ],
      },
      chosenTags: [],
      tags: [],
      profileTags: [],
      image: null,
      imageExt: "",
      usernames: "",
      genders: ["Male", "Female", "Non-Binary", "Other"],
      follow: false,
      filteredNews: [],
      filteredComments: [],
      stateSwitch: true,
      errorUpdateMessage: "Please Complete Profile",
      snackbar: false,
      tagDialog: false,
      codeSent: false,
      verifyCode: "",
    };
  },
  computed: {
    ...mapState(["user", "userProfile"]),
    computedCounterValue() {
      return this.chosenTags.length;
    },
  },
  watch: {
    $route(to, from) {
      if (to !== from) {
        this.pullFromDatabase();
      }
    },
  },

  methods: {
    isCurrentUser() {
      return this.$store.getters.userProfile.uid === this.$route.params.id;
    },
    filtered(str) {
      if (str == "likes") {
        return this.filteredNews;
      } else {
        return this.filteredComments;
      }
    },
    sendCode() {
      this.codeSent = true;
    },
    verifyOneCode() {},
    email() {
      window.location.href = `mailto:${this.userEmail}`;
    },
    currentUser() {
      return this.$route.params.id;
    },
    report() {
      if (this.chosenReason != "") {
        this.$store.dispatch("reportUser", {
          user_id: this.$route.params.id,
          reasonstr: this.reportReason,
          chosenReason: this.chosenReason,
        });

        this.resetReport();
      }
    },
    resetReport() {
      this.reportDialog = false;
      this.reportReason = "";
      this.chosenReason = "";
    },
    adjustOptions() {
      // if (this.chosenTags.length >= this.maxSelected) {
      //   this.menuProps.disabled = true;
      // } else {
      //   this.menuProps.disabled = false;
      // }
    },
    openResource(type, id) {
      if (!this.isCurrentUser()) {
        this.$router.push("/" + type + "/" + id);
      }
    },
    setDialog(supporters, title) {
      if (supporters.length > 0) {
        this.support = true;
        this.supportDialog.supporter_ids = supporters;
        this.supportDialog.title = title;
      }
    },
    onUpdateProfile() {
      if (
        !this.editedFirstName ||
        this.editedFirstName == "" ||
        !this.editedLastName ||
        this.editedLastName == "" ||
        !this.editedPhone ||
        this.editedPhone.length != 10 ||
        !this.editedBirthday ||
        this.editedBirthday == "" ||
        !this.editedGender ||
        this.editedGender == "" ||
        !this.editedState ||
        this.editedState == "" ||
        !this.chosenTags ||
        this.chosenTags == [] ||
        this.chosenTags.length == 0
      ) {
        this.errorUpdateMessage = "Please Fix or Complete Field(s): ";
        if (!this.editedFirstName || this.editedFirstName == "")
          this.errorUpdateMessage += "First Name, ";
        if (!this.editedLastName || this.editedLastName == "")
          this.errorUpdateMessage += "Last Name, ";
        if (!this.editedPhone || this.editedPhone.length != 10)
          this.errorUpdateMessage += "Phone Number, ";

        if (!this.editedBirthday || this.editedBirthday == "")
          this.errorUpdateMessage += "Birthdate, ";
        if (!this.editedGender || this.editedGender == "")
          this.errorUpdateMessage += "Gender, ";
        if (!this.editedState || this.editedState == "")
          this.errorUpdateMessage += "Location, ";
        if (!this.chosenTags || this.chosenTags == [])
          this.errorUpdateMessage += "Choose at Least One Tag, ";

        this.errorUpdateMessage = this.errorUpdateMessage.slice(0, -2) + ".";
        this.verified = true;
      } else {
        if (this.editedUsername == "") {
          var num = 1;
          this.editedUsername =
            this.editedFirstName.split(" ").join("") +
            "-" +
            this.editedLastName.split(" ").join("");
          while (this.usernames.includes(this.editedUsername + "-" + num)) {
            num++;
          }
          this.editedUsername += "-";
          this.editedUsername += num;
        }

        this.verified = false;
        this.editing = false;
        var dateNow = new Date();
        var hours = dateNow.getHours();
        if (hours > 12) {
          hours -= 12;
        }
        var datestring =
          ("0" + (dateNow.getMonth() + 1)).slice(-2) +
          "/" +
          ("0" + dateNow.getDate()).slice(-2) +
          "/" +
          dateNow.getFullYear() +
          " " +
          ("0" + hours).slice(-2) +
          ":" +
          ("0" + dateNow.getMinutes()).slice(-2);
        if (dateNow.getHours() <= 12) {
          datestring += "am";
        } else {
          datestring += "pm";
        }
        var date =
          this.editedBirthday.substring(5, 7) +
          "/" +
          this.editedBirthday.substring(8, 10) +
          "/" +
          this.editedBirthday.substring(0, 4);

        if (this.image) {
          this.$store.dispatch("updateUserPic", {
            image: this.image,
          });
        }
        var finalTags = this.chosenTags == null ? [] : this.chosenTags;
        var j = 0;
        while (j < finalTags.length) {
          if (this.possibleTags.location.includes(finalTags[j])) {
            finalTags = finalTags.splice(j, 1);
            break;
          } else {
            ++j;
          }
        }

        this.$store.dispatch("updateUserData", {
          firstname: this.editedFirstName.toLowerCase(),
          lastname: this.editedLastName.toLowerCase(),
          phone: this.editedPhone,
          email: this.userEmail,
          birthdate: this.editedBirthday,
          gender: this.editedGender,
          zipcode: this.editedZipcode,
          updated: datestring,
          bio: this.editedBio,
          username: this.editedUsername.toLowerCase(),
          state: this.editedState,
          emailSwitch: this.emailSwitch,
          stateSwitch: this.stateSwitch,
          tags: finalTags,
          newsletter: this.newsletter,
        });

        if (this.username !== this.editedUsername) {
          this.$store.dispatch("updateUsername", {
            username: this.editedUsername,
          });
        }
        this.profileTags = [];
        this.profileTags = finalTags;
        (this.state = this.editedState),
          (this.bio = this.editedBio),
          (this.zipcode = this.editedZipcode),
          (this.updated = datestring),
          (this.name = this.editedFirstName + " " + this.editedLastName),
          (this.avatar = this.editedAvatar),
          (this.phone = this.editedPhone),
          (this.email = this.userEmail),
          (this.location = this.editedLocation),
          (this.birthdate = date),
          (this.gender = this.editedGender),
          (this.username = this.editedUsername.toLowerCase()),
          this.$emit("satisfy", true);
      }
      this.userProfile.name = this.editedFirstName + " " + this.editedLastName;
      this.userProfile.firstname = this.editedFirstName.toLowerCase();
      this.userProfile.lastname = this.editedLastName.toLowerCase();
      this.userProfile.phone = this.editedPhone;
      this.userProfile.email = this.userEmail;
      this.userProfile.birthdate = this.editedBirthday;
      this.userProfile.gender = this.editedGender;
      this.userProfile.zipcode = this.editedZipcode;
      this.userProfile.updated = datestring;
      this.userProfile.location = this.editedLocation;
      this.userProfile.bio = this.editedBio;
      this.userProfile.username = this.editedUsername.toLowerCase();
      this.userProfile.state = this.editedState;
      this.userProfile.emailSwitch = this.emailSwitch;
      this.userProfile.stateSwitch = this.stateSwitch;
      this.userProfile.tags = finalTags;
      this.userProfile.newsletter = this.newsletter;
      this.userProfile.profile = true;
      this.snackbar = true;
    },
    onCloseEdit() {
      this.editing = false;
    },
    onClickEdit() {
      this.editing = true;
    },
    onPickFile() {
      this.$refs.fileInput.click();
    },
    onFilePicked(event) {
      const files = event.target.files;
      let fileName = files[0].name;
      if (fileName.lastIndexOf(".") <= 0) {
        alert("Please add a valid image (.jpg, .png, .gif)");
      }
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.imageUrl = fileReader.result;
        this.imageURLExist = true;
      });
      fileReader.readAsDataURL(files[0]);
      this.image = files[0];
    },
    openPost(n) {
      this.$store.dispatch("addInteract", {
        tags: n.tags,
        value: 50000,
      });

      this.$router.push("/" + n.type + "/" + n.id);
    },
    nothing() {},
    pullFromDatabase() {
      this.possibleTags.topics = this.possibleTags.topics.sort();
      this.showSupporter = false;
      this.showPromoted = false;
      this.loading = true;

      if (!this.isCurrentUser()) {
        firebase
          .firestore()
          .collection("users")
          .doc(this.$route.params.id)
          .get()
          .then((doc) => {
            this.editing = false;
            if (doc.data().name) {
              this.name = doc.data().name;
            } else {
              this.name = "";
            }
            if (doc.data().photoURL) {
              this.imageUrl = doc.data().photoURL;
              this.imageURLExist = true;
            } else {
              this.imageUrl = "";
              this.imageURLExist = false;
            }
            if (doc.data().bio) {
              this.bio = doc.data().bio;
            } else {
              this.bio = "";
            }

            if (doc.data().stateSwitch) {
              if (doc.data().state) {
                this.state = doc.data().state;
                this.stateSwitch = true;
              } else {
                this.state = "";
                this.stateSwitch = false;
              }
            } else {
              this.state = "";
              this.stateSwitch = false;
            }

            // if (doc.data().phoneSwitch) {
            //   if (doc.data().phone) {
            //     this.phone = doc.data().phone;
            //     this.phoneSwitch = true;
            //   } else {
            //     this.phone = "";
            //     this.phoneSwitch = false;
            //   }
            // } else {
            //   this.phone = "";
            //   this.phoneSwitch = false;
            // }

            if (doc.data().emailSwitch) {
              if (doc.data().email) {
                this.userEmail = doc.data().email;
                this.emailSwitch = true;
              } else {
                this.userEmail = "";
                this.emailSwitch = false;
              }
            } else {
              this.userEmail = "";
              this.emailSwitch = false;
            }

            if (doc.data().username) {
              this.username = doc.data().username;
            } else {
              this.username = "";
            }
            this.profileTags = [];
            if (doc.data().tags) {
              this.profileTags = doc.data().tags;
            } else {
              this.profileTags = [];
            }
            if (doc.data().supporter_ids) {
              this.supporter_ids = doc.data().supporter_ids;
            }

            if (doc.data().promoted_accounts) {
              this.promoted_accounts = doc.data().promoted_accounts;
            }
            var i = 0;
            this.follow = false;
            while (i < this.supporter_ids.length) {
              if (
                this.supporter_ids[i].id === this.$store.getters.userProfile.uid
              ) {
                this.follow = true;
                break;
              } else {
                ++i;
              }
            }

            this.filteredNews = [];
            this.filteredComments = [];
            if (doc.data().forum_posts) {
              doc.data().forum_posts.forEach((val) => {
                firebase
                  .firestore()
                  .collection("concordposts")
                  .doc(val)
                  .get()
                  .then((doc) => {
                    if (doc.data()) {
                      this.filteredNews.push({
                        type: "news",
                        id: doc.id,
                        name: doc.data().name,
                        title: doc.data().title,
                        tags: doc.data().tags,
                        username: null,
                        count: doc.data().count,
                        time: doc.data().time,
                      });
                      const date2 = new Date();
                      this.filteredNews.forEach((value) => {
                        if (
                          value.type == "news" &&
                          typeof value.time != "string"
                        ) {
                          value.timestamp = value.time;

                          this.filteredNews.sort(function(a, b) {
                            return b.timestamp - a.timestamp;
                          });
                          const diffTimes = date2.getTime() - value.time;
                          const diffDayss = Math.floor(
                            diffTimes / (1000 * 60 * 60 * 24)
                          );
                          if (diffDayss < 1) {
                            var diff = (date2.getTime() - value.time) / 1000;
                            diff /= 60 * 60;
                            if (diff < 1) {
                              var minutes = Math.floor(diff * 60);
                              if (Math.abs(Math.round(minutes)) == 1) {
                                value.time =
                                  Math.abs(Math.round(minutes)) + " minute ago";
                              } else {
                                value.time =
                                  Math.abs(Math.round(minutes)) +
                                  " minutes ago";
                              }
                            } else {
                              if (Math.abs(Math.round(diff)) == 1) {
                                value.time = 1 + " hour ago";
                              } else {
                                value.time =
                                  Math.abs(Math.round(diff)) + " hours ago";
                              }
                            }
                          } else {
                            if (diffDayss == 1) {
                              value.time = diffDayss + " day ago";
                            } else if (diffDayss >= 7) {
                              value.time = new Date(value.time).toDateString();
                              value.time =
                                value.time.substring(3, 10) +
                                "," +
                                value.time.substring(10);
                            } else {
                              value.time = diffDayss + " days ago";
                            }
                          }
                        }
                      });
                    }
                  });
              });
            }
          });
        this.loading = false;

        this.$forceUpdate();
      } else {
        this.loading = true;
        var self = this;
        setTimeout(async function() {
          self.userID = self.$store.getters.userProfile.uid;
          self.userEmail = self.user.email;
          self.usernames = self.userNames;
          // user names???
          self.profileTags = [];
          if (self.$store.getters.userProfile.updated) {
            self.updated = self.$store.getters.userProfile.updated;
          }
          if (self.$store.getters.userProfile.name) {
            self.name = self.$store.getters.userProfile.name;
            self.editedFirstName = self.name.substr(0, self.name.indexOf(" "));
            self.editedFirstName =
              self.editedFirstName.charAt(0).toUpperCase() +
              self.editedFirstName.slice(1);
            self.editedLastName = self.name.substr(self.name.indexOf(" ") + 1);
            self.editedLastName =
              self.editedLastName.charAt(0).toUpperCase() +
              self.editedLastName.slice(1);
          }
          if (self.$store.getters.userProfile.username) {
            self.username = self.$store.getters.userProfile.username;
            self.editedUsername = self.$store.getters.userProfile.username;
          }
          if (self.$store.getters.userProfile.bio) {
            self.bio = self.$store.getters.userProfile.bio;
            self.editedBio = self.$store.getters.userProfile.bio;
          }
          if (self.$store.getters.userProfile.gender) {
            self.gender = self.$store.getters.userProfile.gender;
            self.editedGender = self.$store.getters.userProfile.gender;
          }
          if (self.$store.getters.userProfile.location) {
            self.location = self.$store.getters.userProfile.location;
            self.editedLocation = self.$store.getters.userProfile.location;
          }
          if (self.$store.getters.userProfile.tags) {
            self.tags = self.$store.getters.userProfile.tags;
            self.chosenTags = self.$store.getters.userProfile.tags;
            self.profileTags = self.tags;
          }
          if (self.$store.getters.userProfile.zipcode) {
            self.zipcode = self.$store.getters.userProfile.zipcode;
            self.editedZipcode = self.$store.getters.userProfile.zipcode;
          }
          if (self.$store.getters.userProfile.birthdate) {
            self.editedBirthday = self.$store.getters.userProfile.birthdate;
            self.birthdate =
              self.editedBirthday.substring(5, 7) +
              "/" +
              self.editedBirthday.substring(8, 10) +
              "/" +
              self.editedBirthday.substring(0, 4);
          } else {
            self.editedBirthday = "2000-01-01";
          }
          if (self.$store.getters.userProfile.phone) {
            self.phone = self.$store.getters.userProfile.phone;
            self.editedPhone = self.$store.getters.userProfile.phone;
          }
          if (self.$store.getters.userProfile.state) {
            self.state = self.$store.getters.userProfile.state;
            self.editedState = self.$store.getters.userProfile.state;
          }
          if (self.$store.getters.userProfile.stateSwitch) {
            self.stateSwitch = self.$store.getters.userProfile.stateSwitch;
          } else {
            self.stateSwitch = false;
          }
          if (self.$store.getters.userProfile.emailSwitch) {
            self.emailSwitch = self.$store.getters.userProfile.emailSwitch;
          } else {
            self.emailSwitch = false;
          }
          if (self.$store.getters.userProfile.photoURL) {
            self.imageUrl = self.$store.getters.userProfile.photoURL;
            if (
              self.imageUrl == "" ||
              self.imageUrl == undefined ||
              self.imageUrl == null
            ) {
              self.imageURLExist = false;
            } else {
              self.imageURLExist = true;
            }
          }
          if (self.$store.getters.userProfile.joined) {
            self.joined = self.$store.getters.userProfile.joined;
          }
          if (self.$store.getters.userProfile.updated) {
            self.updated = self.$store.getters.userProfile.updated;
          }
          if (self.$store.getters.userProfile.supporter_ids) {
            self.supporter_ids = self.$store.getters.userProfile.supporter_ids;
          }
          if (!self.$store.getters.userProfile.profile) {
            self.editing = true;
            firebase
              .firestore()
              .collection("usernames")
              .doc("usernames")
              .get()
              .then((doc) => {
                if (doc && doc.data()) {
                  self.usernames = doc.data().names;
                }
              });
          } else {
            self.editing = false;
          }

          if (self.$store.getters.userProfile.promoted_accounts) {
            self.promoted_accounts =
              self.$store.getters.userProfile.promoted_accounts;
          }
          if (self.$store.getters.userProfile.comment_count) {
            self.comment_count = self.$store.getters.userProfile.comment_count;
          }

          if (self.userProfile.imageExt) {
            self.imageExt =
              "https://firebasestorage.googleapis.com/v0/b/mirror2019-b60e0.appspot.com/o/users%2F" +
              self.user.uid +
              self.userProfile.imageExt +
              "?alt=media";
          }
          self.filteredNews = [];
          self.filteredComments = [];
          if (self.$store.getters.userProfile.forum_posts) {
            await self.$store.getters.userProfile.forum_posts.forEach((val) => {
              firebase
                .firestore()
                .collection("concordposts")
                .doc(val)
                .get()
                .then((doc) => {
                  if (doc.data()) {
                    self.filteredNews.push({
                      type: "news",
                      id: doc.id,
                      name: doc.data().name,
                      title: doc.data().title,
                      tags: doc.data().tags,
                      username: null,
                      count: doc.data().count,
                      time: doc.data().time,
                    });
                    const date2 = new Date();
                    self.filteredNews.forEach((value) => {
                      if (
                        value.type == "news" &&
                        typeof value.time != "string"
                      ) {
                        value.timestamp = value.time;

                        self.filteredNews.sort(function(a, b) {
                          return b.timestamp - a.timestamp;
                        });
                        const diffTimes = date2.getTime() - value.time;
                        const diffDayss = Math.floor(
                          diffTimes / (1000 * 60 * 60 * 24)
                        );
                        if (diffDayss < 1) {
                          var diff = (date2.getTime() - value.time) / 1000;
                          diff /= 60 * 60;
                          if (diff < 1) {
                            var minutes = Math.floor(diff * 60);
                            if (Math.abs(Math.round(minutes)) == 1) {
                              value.time =
                                Math.abs(Math.round(minutes)) + " minute ago";
                            } else {
                              value.time =
                                Math.abs(Math.round(minutes)) + " minutes ago";
                            }
                          } else {
                            if (Math.abs(Math.round(diff)) == 1) {
                              value.time = 1 + " hour ago";
                            } else {
                              value.time =
                                Math.abs(Math.round(diff)) + " hours ago";
                            }
                          }
                        } else {
                          if (diffDayss == 1) {
                            value.time = diffDayss + " day ago";
                          } else if (diffDayss >= 7) {
                            value.time = new Date(value.time).toDateString();
                            value.time =
                              value.time.substring(3, 10) +
                              "," +
                              value.time.substring(10);
                          } else {
                            value.time = diffDayss + " days ago";
                          }
                        }
                      }
                    });
                  }
                });
            });
          }
          if (self.$store.getters.userProfile.forum_commentposts) {
            await self.$store.getters.userProfile.forum_commentposts.forEach(
              (val) => {
                // eslint-disable-next-line no-console
                console.log(val);
                firebase
                  .firestore()
                  .collection("concordposts")
                  .doc(val.id)
                  .get()
                  .then((doc) => {
                    if (doc.data()) {
                      self.filteredComments.push({
                        type: "news",
                        id: doc.id,
                        name: doc.data().name,
                        title: doc.data().title,
                        tags: doc.data().tags,
                        username: null,
                        count: doc.data().count,
                        time: doc.data().time,
                        comment: val.comment,
                      });
                      const date2 = new Date();
                      self.filteredComments.forEach((value) => {
                        if (
                          value.type == "news" &&
                          typeof value.time != "string"
                        ) {
                          value.timestamp = value.time;

                          self.filteredComments.sort(function(a, b) {
                            return b.timestamp - a.timestamp;
                          });
                          const diffTimes = date2.getTime() - value.time;
                          const diffDayss = Math.floor(
                            diffTimes / (1000 * 60 * 60 * 24)
                          );
                          if (diffDayss < 1) {
                            var diff = (date2.getTime() - value.time) / 1000;
                            diff /= 60 * 60;
                            if (diff < 1) {
                              var minutes = Math.floor(diff * 60);
                              if (Math.abs(Math.round(minutes)) == 1) {
                                value.time =
                                  Math.abs(Math.round(minutes)) + " minute ago";
                              } else {
                                value.time =
                                  Math.abs(Math.round(minutes)) +
                                  " minutes ago";
                              }
                            } else {
                              if (Math.abs(Math.round(diff)) == 1) {
                                value.time = 1 + " hour ago";
                              } else {
                                value.time =
                                  Math.abs(Math.round(diff)) + " hours ago";
                              }
                            }
                          } else {
                            if (diffDayss == 1) {
                              value.time = diffDayss + " day ago";
                            } else if (diffDayss >= 7) {
                              value.time = new Date(value.time).toDateString();
                              value.time =
                                value.time.substring(3, 10) +
                                "," +
                                value.time.substring(10);
                            } else {
                              value.time = diffDayss + " days ago";
                            }
                          }
                        }
                      });
                    }
                  });
              }
            );
          }
          self.loading = false;

          self.$forceUpdate();
        }, 200);
      }
    },
    Follow() {
      this.follow = !this.follow;
      this.supporter_ids.push({
        id: this.$store.getters.userProfile.uid,
        name: this.$store.getters.userProfile.name,
      });
      this.$store.dispatch("addFollow", {
        followID: this.$route.params.id,
        name: this.name,
        userID: this.$store.getters.userProfile.uid,
        userName: this.$store.getters.userProfile.name,
      });
    },
    Unfollow() {
      this.follow = !this.follow;
      var i = 0;
      while (i < this.supporter_ids.length) {
        if (this.supporter_ids[i].id === this.$store.getters.userProfile.uid) {
          this.supporter_ids.splice(i, 1);
          break;
        } else {
          ++i;
        }
      }
      this.$store.dispatch("unfollow", {
        unfollowID: this.$route.params.id,
        userID: this.$store.getters.userProfile.uid,
      });
    },
    pushTag(tag) {
      if (this.possibleTags.location.includes(tag)) {
        this.$router.replace({
          name: "search",
          params: {
            location: tag,
            id: undefined,
          },
        });
      } else {
        this.$router.replace({
          name: "search",
          params: {
            tags: tag,
            id: undefined,
          },
        });
      }
    },
    deletePost(id) {
      this.$store.dispatch("deleteStory", {
        oldforum: id,
      });
      this.removeFromNews(id);
      this.$forceUpdate();
    },
    removeFromNews(id) {
      var i = 0;
      for (i = 0; i < this.filteredNews.length; i++) {
        if (this.filteredNews[i].forum_id == id) {
          this.filteredNews.splice(i, 1);
        }
      }
    },
    formatNumber(num) {
      var _return = "(";
      var ini = num.substring(0, 3);
      _return += ini + ")-";
      var st = num.substring(3, 6);
      _return += st + "-";
      var end = num.substring(6, 10);
      _return += end;
      return _return;
    },
  },
  created() {
    this.pullFromDatabase();
  },
};
</script>
